module.exports = __webpack_public_path__ + "img/Sign_5.ff8394d9.png";